import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class SalariesConfirmationVM extends InterActive{
    private list:{marketer_id:string , name: string , total_sales:string}[] = []

    public get List():{marketer_id:string , name: string , total_sales:string}[] { return this.list }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.GetMarketersSalaryConfirmationLis()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.list = response.data.data
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public async confirm(data:{id:string , target:string , cut:string , bounus:string , notes:string}){
        try{
            const response = await ApiRequest.confirmSalary(data)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'تمت العملية بنجاح' , body:'تم اعتماد الراتب بنجاح'})
                    }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                }else  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{
            Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
        }
    }

}